import css from './style.module.scss';
import {FC} from "react";
import Header from "../../components/header";

type Props = {
    amount: number,
    onRestart: () => void,
    isShowing: boolean,
    isPrev: boolean,
}

const S3: FC<Props> = ({
    amount,
    onRestart,
    isShowing,
    isPrev
}) => {

    const isWin = amount > 0;
    const headerStatus = isWin ? "success" : "fail";
    const header = isWin ? "It's best talaga to\nbe prepared." : "Life happens. Kaya, it's best to be prepared.";
    const subtext = isWin
        ? "Because the only thing worse about\ngetting sick is the cost of getting well."
        : "Because the only thing worse about\ngetting sick is the cost of getting well.\nDon't worry. It's not too late!";

    const hero = "./images/positive-result.png";

    const type = isPrev ? "prev" : isShowing ? "show" : "hide";

    return (
        <div className={css.content} data-type={type}>
            <Header status={headerStatus} sum={amount}/>
            <div className={css.textWrapper}>
                <div className={css.text}>{header}</div>
                <div className={css.text2}>{subtext}</div>
            </div>
            <div className={css.hero}>
                <img src={hero} alt={"Hero banner"}/>
            </div>
            <div className={css.btnWrapper}>
                <a className={css.btn} href={"https://www.sunlife.com.ph/en/"} target={"_blank"} rel={"noreferrer"}>
                    START PREPARING TODAY
                </a>
                <div className={css.restart} onClick={onRestart}>
                    TRY THE GAME AGAIN
                </div>
            </div>
        </div>
    )
}

export default S3;
